import { useState } from 'react';
import { Ticket } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SectionHeader from '../components/SectionHeader';
import ContactInquiryForm from '../components/ContactInquiryForm';
import { SITE_NAME } from '../constants/site';

const SAMPLE_BOOKINGS = [
  { id: 'FH-10294', type: 'Flight', detail: 'JFK → MIA', date: 'Jun 12, 2026', status: 'Confirmed' },
  { id: 'FH-10295', type: 'Hotel', detail: 'Grand Vista Paris', date: 'Jul 3 – Jul 7, 2026', status: 'Confirmed' },
];

export default function MyBookingsPage() {
  const [confirmation, setConfirmation] = useState('');
  const [lastName, setLastName] = useState('');
  const [found, setFound] = useState(null);
  const [error, setError] = useState('');

  const handleLookup = (e) => {
    e.preventDefault();
    setError('');
    const match = SAMPLE_BOOKINGS.find(
      (b) => b.id.toLowerCase() === confirmation.trim().toLowerCase()
    );
    if (match && lastName.length >= 2) {
      setFound(match);
    } else {
      setFound(null);
      setError('No booking found. Check your confirmation code and last name, or use the help form below.');
    }
  };

  return (
    <>
      <Header />
      <section className="page-banner page-banner--compact">
        <div className="container">
          <SectionHeader
            eyebrow="Your trips"
            title="My Bookings"
            subtitle={`Retrieve your ${SITE_NAME} reservation with confirmation code and last name.`}
            light
          />
        </div>
      </section>
      <div className="container page-content-premium my-bookings-page">
        <div className="panel-premium">
          <form className="lookup-form" onSubmit={handleLookup}>
            <label>
              Confirmation code
              <input
                value={confirmation}
                onChange={(e) => setConfirmation(e.target.value)}
                placeholder="e.g. FH-10294"
                required
              />
            </label>
            <label>
              Last name
              <input
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="Traveler last name"
                required
              />
            </label>
            <button type="submit" className="btn-gold">
              Find booking
            </button>
          </form>
          {error && <p className="form-error" role="alert">{error}</p>}
          {found && (
            <article className="booking-found">
              <Ticket size={28} aria-hidden />
              <div>
                <h2>Booking {found.id}</h2>
                <p>
                  <strong>{found.type}</strong> — {found.detail}
                </p>
                <p>{found.date}</p>
                <span className="badge badge--success">{found.status}</span>
              </div>
            </article>
          )}
        </div>
        <aside className="panel-premium panel-premium--muted">
          <h3>Need help?</h3>
          <p>Cannot find your booking? Send us your name, email, and phone — we will assist you.</p>
          <ContactInquiryForm
            className="lookup-form contact-inquiry-form contact-inquiry-form--spaced"
            subject={`${SITE_NAME} — Booking help request`}
            submitLabel="Request help"
            showMessage
            messageRequired
            successMessage="Your request was sent. Our team will contact you shortly."
          />
        </aside>
      </div>
      <Footer />
    </>
  );
}
